import { createSelector } from 'reselect';
import { isEqual } from 'underscore';
import { EditSceneModalState } from './types';

export const slotsSelector = (state: EditSceneModalState) => state.slots;
export const slotCountSelector = (state: EditSceneModalState) =>
  state.slotCount;

export const isBackgroundBlurEnabledSelector = (state: EditSceneModalState) =>
  state.enableBlur;

export const captionsOverrideSelector = (state: EditSceneModalState) =>
  state.captionsOverride;

const captionsOverridePositionSelector = (state: EditSceneModalState) =>
  captionsOverrideSelector(state)?.position;

export const defaultCaptionsOverrideSelector = (state: EditSceneModalState) =>
  state.defaultCaptionsOverride;

const defaultCaptionsOverridePositionSelector = (state: EditSceneModalState) =>
  defaultCaptionsOverrideSelector(state)?.position;

export const isBackgroundBlurDirtySelector = (state: EditSceneModalState) =>
  isBackgroundBlurEnabledSelector(state) !== state.defaultEnableBlur;

export const isCaptionsOverrideDirtySelector = createSelector(
  [captionsOverridePositionSelector, defaultCaptionsOverridePositionSelector],
  (captionsOverridePosition, defaultCaptionsOverridePosition) => {
    return !isEqual(captionsOverridePosition, defaultCaptionsOverridePosition);
  },
);
